import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationGr from "./locales/gr.json";
import translationIT from "./locales/it.json";
import translationRS from "./locales/ru.json";
import translationSP from "./locales/sp.json";
import translationENG from "./locales/en.json";
import translationCN from "./locales/ch.json";
import translationFR from "./locales/fr.json";
import translationAR from "./locales/ar.json";
import translationPtBR from "./locales/pt-BR.json";
import translationES from "./locales/es.json";

// Locales de produto F1: pt-BR (default), en, es — DOC 09 § 8 / 12.
// Demais arquivos Velzon ficam registrados para demos legadas até LAC-011.
const resources = {
  "pt-BR": {
    translation: translationPtBR,
  },
  en: {
    translation: translationENG,
  },
  es: {
    translation: translationES,
  },
  sp: {
    translation: translationSP,
  },
  gr: {
    translation: translationGr,
  },
  it: {
    translation: translationIT,
  },
  rs: {
    translation: translationRS,
  },
  cn: {
    translation: translationCN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
// Migra locale legado Velzon "sp" → "es" (DOC 12: pt-BR | en | es).
if (language === "sp") {
  localStorage.setItem("I18N_LANGUAGE", "es");
}

/** Porta brsend.com: default EN até o usuário escolher (DOC 20 § 4.3). */
function defaultLocaleForHost(): string {
  if (typeof window !== "undefined" && /(^|\.)brsend\.com$/i.test(window.location.hostname)) {
    return "en";
  }
  return "pt-BR";
}

/**
 * CTA do site → ?lang= (whitelist). Mercado (USD) vem em ?market=intl — não confundir.
 * Por quê: brsend em PT deve abrir o register em PT, mesmo cobrando USD.
 */
function localeFromQuery(): string | null {
  if (typeof window === "undefined") return null;
  const raw = new URLSearchParams(window.location.search).get("lang");
  if (!raw) return null;
  const normalized = raw.replace("_", "-").toLowerCase();
  if (normalized === "pt" || normalized === "pt-br") return "pt-BR";
  if (normalized === "en") return "en";
  if (normalized === "es") return "es";
  return null;
}

const fromQuery = localeFromQuery();
if (fromQuery) {
  localStorage.setItem("I18N_LANGUAGE", fromQuery);
}

if (!localStorage.getItem("I18N_LANGUAGE")) {
  localStorage.setItem("I18N_LANGUAGE", defaultLocaleForHost());
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || defaultLocaleForHost(),
    fallbackLng: {
      "pt-BR": ["en"],
      es: ["en"],
      default: ["pt-BR", "en"],
    },
    // Chaves de produto usam ponto literal (ex.: settings.sending.title).
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
